import { Vue, Component } from 'vue-property-decorator'
import { Getter, Mutation } from 'vuex-class'
import * as S from '@/@next/store/style/index'
import { cloneDeep } from 'lodash'

@Component({ name: 'style-mixin' })
export default class Style extends Vue {

  @Getter(S.GET_ACCESSIBILITY) _accessibility!: any
  @Getter(S.GET_LOCAL_STYLE) _localStyle!: any
  @Getter(S.GET_DEFAULT_STYLE) _defaultStyle!: any
  @Getter(S.GET_HIGH_CONTRAST_STYLE) _highContrastStyle!: any
  @Getter(S.GET_ACCESSIBILTY_KEYS) _accessibilityKeys!: any
  @Getter(S.GET_STYLE_KEYS) _styleKeys!: any

  @Mutation(S.SET_ACCESSIBILITY) _setAccessibility!: (props: any) => any
  @Mutation(S.SET_LOCAL_STYLE) _setLocalStyle!: (style: any) => any
  @Mutation(S.SET_DEFAULT_STYLE) _setDefaultStyle!: (style: any) => any

  /* Word Spacing */
  maxWordSpacing = 10
  minWordSpacing = 0
  wordSpacingStep = 5
  /* Text Size Value */
  maxTextSize = 140
  minTextSize = 100
  textSizeStep = 20
  
  setStyle (property: string, value: string) {
    const root = document.documentElement
    if (!value?.length || !property?.length) return
    root.style.setProperty(property, value)
  }

  /* text Size */
  get _textSize ()  {
    return this._accessibility.textSize
  }

  set _textSize (textSize: number) {
    if (textSize > this.maxTextSize) textSize = this.maxTextSize
    else if (textSize < this.minTextSize) textSize = this.minTextSize
    document.body.style.fontSize = `${textSize.toString()}%`
    this._setAccessibility({ textSize })
  }

  scaleText (direction: string) {
    this._textSize += direction === 'up' ? this.textSizeStep : - this.textSizeStep
  }

  /* Word Spacing */
  get _wordSpacing () {
    return this._accessibility.wordSpacing
  }

  set _wordSpacing (wordSpacing: number) {
    if (wordSpacing > this.maxWordSpacing) wordSpacing = this.maxWordSpacing
    else if (wordSpacing < this.minWordSpacing) wordSpacing = this.minWordSpacing
    document.body.style.wordSpacing = `${wordSpacing.toString()}px`
    this._setAccessibility({ wordSpacing })
  }

  scaleWordSpacing (direction: string) {
    this._wordSpacing += direction === 'up' ? this.wordSpacingStep : - this.wordSpacingStep
  }

  /* Gray Scale */
  get _greyScale () {
    return this._accessibility.greyScale
  }
  set _greyScale (greyScale: boolean) {
    document.body.style.filter = greyScale ? 'grayscale(100%)' : 'none'
    this._setAccessibility({ greyScale })
  }

  /* Hight Contract */
  get _highContrast () {
    return this._accessibility.highContrast
  }

  set _highContrast (highContrast: boolean) {
    this._setAccessibility({ highContrast })
    this.updateStyle()
  }

  /* Dyslexic Font */
  get _dyslexicFont () {
    return this._accessibility.dyslexicFont
  }

  set _dyslexicFont (dyslexicFont: boolean) {
    this.setStyle('--sansSerifFontStack', dyslexicFont ? 'OpenDyslexic' : this._defaultStyle.sansSerifFontStack)
    this.setStyle('--serifFontStack', dyslexicFont ? 'OpenDyslexic' : this._defaultStyle.serifFontStack)
    this._setAccessibility({ dyslexicFont })
  }

  /* Text To Speech */
  get _textToSpeech () {
    return this._accessibility.textToSpeech
  }

  set _textToSpeech (textToSpeech: boolean) {
    this._setAccessibility({ textToSpeech })
  }

  updateAccessibility (props: any) {
    for (const [key, value] of Object.entries(props)) {
        if (this._accessibilityKeys.includes(key)) {
          (this as any)[`_${key}`] = value;
        }
    }
  }

  updateStyle () {
    try {
      for (const key of this._styleKeys) {
        const loc = this._localStyle?.[key]
        const highContrast = this._highContrast && this._highContrastStyle[key]
        const def = this._defaultStyle[key]
        const value = highContrast?.length > 0 ? highContrast : (loc?.length > 0 ? loc : def)
        this.setStyle(`--${key}`, value as string);
      }
    } catch (e) {
      console.error('Error updating style', e)
    }
    
  }

  updateLocalStyle (style: any | null) {
    this._setLocalStyle(style || null)
    this.updateStyle()
  }

  updateDefaultStyle (style: any) {
    this._setDefaultStyle(style || {})
    this.updateStyle()
  }

}
